// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List all googleformresponse
export const viewGoogleResponse = createAsyncThunk(
  "googleformresponse",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}backend-api/googleFormResponse`,
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  },
);

// List only approved googleformresponse
export const googleResponseByApplicationType = createAsyncThunk(
  "googleformresponse",
  async (applicationType, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}backend-api/googleFormResponse-applicationType/applicationType/`,
        {
          params: { applicationType }, // Adds ?applicationType=YourValue
        },
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  },
);

// Add new GoogleResponse
export const newGoogleResponse = createAsyncThunk(
  "googleformresponse",
  async (internshipData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}backend-api/googleFormResponse`,
        internshipData,
      );
      // console.log("response : ", response);
      return handleApiResponse(response, thunkAPI, "Register successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Search GoogleResponse by ID
export const singleGoogleResponse = createAsyncThunk(
  "googleformresponse",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}backend-api/googleFormResponse/${id}`,
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "search GoogleResponse ...");
    }
  },
);

// Update GoogleResponse
export const updateGoogleResponse = createAsyncThunk(
  "googleformresponse",
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BaseUrl}backend-api/googleFormResponse/${id}`,
        formData,
      );
      return handleApiResponse(response, thunkAPI, "Change saved successfully");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Delete GoogleResponse
export const deleteGoogleResponse = createAsyncThunk(
  "googleformresponse",
  async (id, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem("userInfo")) || null;
    try {
      const response = await axios.delete(
        `${BaseUrl}backend-api/googleFormResponse/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return handleApiResponse(response, thunkAPI, "Delete successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);
